module.exports = __webpack_public_path__ + "img/grade20.682a943c.png";